import { ReactComponent as GlobalIcon } from "images/global.svg";
import { ReactComponent as DownArrowIcon } from "images/down-arrow.svg";
import { HStack } from "components/Stack";
import "./style.css";
import { Popover, PopoverProps } from "@material-ui/core";
import { MouseEvent, useMemo, useState } from "react";
import { patchUserProfile } from "../../services/users";
import { updateUser } from "../../services/authUtil";
import { useTranslation } from "react-i18next";
import useUser from "hooks/useUser";

type Props = {
  className?: string;
  onSelect: (value: string) => void;
  value: string;
  color?: string;
};

export const LANGUAGES = [
  { name: "English", value: "en" },
  { name: "Deutsch", value: "de" },
  { name: "Spanish", value: "es" },
  { name: "Chinese", value: "zh" },
];

type LanguageDropdownProps = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSelect: (value: string) => void;
  transformOrigin?: PopoverProps["transformOrigin"];
  value: string;
};

export function LanguageDropdown(props: LanguageDropdownProps) {
  const { i18n } = useTranslation();
  const user = useUser();

  const hdSelect = (value: string) => {
    if (value !== props.value) {
      i18n.changeLanguage(value).then(() => {
        if (user) {
          updateUser({
            ...user,
            localization_lang: value,
          });
        }

        props.onSelect(value);

        patchUserProfile({ localization_lang: value });
      });
    }
  };

  return (
    <Popover
      anchorEl={props.anchorEl}
      open={Boolean(props.anchorEl)}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={
        props.transformOrigin || {
          vertical: "top",
          horizontal: "left",
        }
      }
      PaperProps={{
        className: "page-header-menu language-selector-menu",
      }}
    >
      {LANGUAGES.map(lang => {
        return (
          <div
            key={lang.value}
            className="menu-item"
            onClick={() => hdSelect(lang.value)}
          >
            <span className="menu-label">{lang.name}</span>
          </div>
        );
      })}
    </Popover>
  );
}

export default function LanguageSelector(props: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const selectedLang = useMemo(
    () => LANGUAGES.find(v => v.value === props.value) || LANGUAGES[0],
    [props.value]
  );

  const hdOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const hdSelect = (v: string) => {
    props.onSelect(v);
    setAnchorEl(null);
  };

  return (
    <>
      <div onClick={hdOpen}>
        <HStack
          gap={"6px"}
          align={"center"}
          className={`language-selector ${props.className || ""}`}
          style={{ color: props.color || "white" }}
        >
          <GlobalIcon style={{ color: "inherit" }} />
          <div className={"language"}>{(selectedLang.value || "").toUpperCase()}</div>
          <DownArrowIcon style={{ color: "inherit" }} />
        </HStack>
      </div>

      <LanguageDropdown
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onSelect={hdSelect}
        value={props.value}
      />
    </>
  );
}
